class SheeruFilters extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const form = this.querySelector('form');
    form.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // Handle Drawer Toggles
    const openBtns = document.querySelectorAll('.js-open-filter-drawer');
    const closeBtns = document.querySelectorAll('.js-close-filter-drawer');
    const overlay = document.querySelector('.sheeru-drawer-overlay');

    openBtns.forEach(btn => btn.addEventListener('click', () => document.body.classList.add('sheeru-drawer-active')));
    closeBtns.forEach(btn => btn.addEventListener('click', () => document.body.classList.remove('sheeru-drawer-active')));
    if(overlay) overlay.addEventListener('click', () => document.body.classList.remove('sheeru-drawer-active'));
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  renderPage(searchParams, event) {
    const url = `${window.location.pathname}?${searchParams}`;
    
    // Update Browser URL
    history.pushState({ searchParams }, '', url);

    // Fetch new data
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        // Update Grid
        this.renderProductGrid(html);
        
        // Update Filter Counts/Status
        this.renderFilters(html, event);
      });
  }

  renderProductGrid(html) {
    const gridSource = html.getElementById('SheeruProductGridContainer');
    const gridTarget = document.getElementById('SheeruProductGridContainer');
    if (gridSource && gridTarget) gridTarget.innerHTML = gridSource.innerHTML;
    
    const countSource = html.getElementById('SheeruCount');
    const countTarget = document.getElementById('SheeruCount');
    if (countSource && countTarget) countTarget.innerHTML = countSource.innerHTML;
  }

  renderFilters(html, event) {
    const filterSource = html.getElementById('SheeruFiltersForm');
    const filterTarget = document.getElementById('SheeruFiltersForm');
    if (filterSource && filterTarget) filterTarget.innerHTML = filterSource.innerHTML;
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('sheeru-filters', SheeruFilters);